{
    "raporkampanya": {
        "Baslik": "Campagnerapport",
        "Kampanya": "Campagne",
        "Kullanici": "Gebruiker / Team",
        "Detay": "Detail",
        "Urun": "Product",
        "HedefAdet": "Doelhoeveelheid",
        "HedefTutar": "Doelbedrag",
        "OnayliAdet": "Goedgekeurde Hoeveelheid",
        "OnayliTutar": "Goedgekeurd Bedrag",
        "OnayliApe": "Goedgekeurde APE",
        "IptalAdet": "Geannuleerde Hoeveelheid",
        "IptalTutar": "Geannuleerd Bedrag",
        "IptalApe": "Geannuleerde APE",
        "CaymaAdet": "Opnamehoeveelheid",
        "Ara": "Zoeken",
        "Temizle": "Wissen",
        "Hedefler": "Doelen",
        "Toplam": "Totaal",
        "Adet": "Aantal",
        "Satislar": "Verkopen"
    }
}
